<template>
<v-layout row wrap>
  <v-flex xs12>
    <div class="v-input v-text-field theme--pt-0">
      <div class="v-input__control">
        <div class="v-input__slot">
          <gmap-autocomplete ref="search" class="v-text-field__slot " label="Job Address" placeholder="Search Address" @place_changed="getAddressData">
          </gmap-autocomplete>
          <v-btn flat icon color="primary" @click="clear">
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </v-flex>
  <v-flex xs12>
    <v-text-field label="address1" v-model="value.address1"></v-text-field>

  </v-flex>
  <v-flex xs12>
    <v-text-field label="address2" v-model="value.address2"></v-text-field>

  </v-flex>
  <v-flex xs6>
    <v-text-field label="city" v-model="value.city"></v-text-field>

  </v-flex>
  <v-flex xs3>
    <v-text-field label="state" v-model="value.state"></v-text-field>

  </v-flex>
  <v-flex xs3>
    <v-text-field label="zip" v-model="value.zip"></v-text-field>

  </v-flex>

</v-layout>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data: {}
    }
  },
  methods: {
    clear () {
      this.$refs.search.$el.value = null
      this.value.address1 = ''
      this.value.address2 = ''
      this.value.city = ''
      this.value.state = ''
      this.value.zip = ''
      this.value.html = ''
    },
    getAddressData: function (addressData) {
      var components = {}
      addressData.address_components.map(k => {
        components[k.types[0]] = k.short_name
      })
      this.data.address1 = `${components.street_number} ${components.route}`

      this.data.city = components.locality
      this.data.state = components.administrative_area_level_1
      this.data.zip = components.postal_code
      this.data.html = addressData.adr_address
      // this.project.address.formatted_address = addressData.formatted_address;
      // this.project.address.adr_address = addressData.adr_address;
      // this.project.address.address_components = addressData.address_components;
      // this.project.location = [addressData.geometry.location.lat(), addressData.geometry.location.lng()]
      this.$refs.search.$el.value = null
      this.$emit('input', this.data)
    }
  },
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  }
}
</script>
